import * as React from "react";

import "./search-input.scss";

import {bindInput} from "@Common/react/bind-input";
import {cs}        from "@Common/react/chain-services";

export const SearchInput = ({state, placeholder, text=undefined, xdQaName=undefined, textQaName=undefined, onBlur=undefined}) => cs(
    () => (
        <div className="search-input search-input-4sz">
            {text && (
                <div className="text" xd-qa-type="text" xd-qa-name={textQaName}>
                    {text}
                </div>
            )}
            <input {...{
                type: "search",
                placeholder,
                maxLength: 50,
                ...bindInput(state),
                onKeyDown: (e) => {
                    e.stopPropagation();
                },
                onBlur,
                "xd-qa-type": "textbox",
                "xd-qa-name": xdQaName,
            }}/>
            {!state.value && (
                <i className="fa fa-search" xd-qa-type="icon" xd-qa-name={xdQaName}/>
            )}
        </div>
    ),
);